import {Injectable} from "@angular/core";
import Swal, {SweetAlertIcon, SweetAlertOptions} from "sweetalert2";

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor() {
  }

  simpleAlert(title: string, html?: string, icon?: SweetAlertIcon) {
    return Swal.fire(title, html, icon);
  }

  successAlert(title: string, html?: string) {
  //  alert()
    return Swal.fire(title || 'Thank you...', html || '', 'success')
  }
  errorsms(title: string, html?: string) {
    //  alert()
      return Swal.fire(title || 'Thank you...', html || '', 'error')
    }

  errorAlert(options?: SweetAlertOptions) {
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      // text: 'Something went wrong!',
      ...options
    })
  }

  warningAlert(options?: SweetAlertOptions) {
    return Swal.fire({
      icon: 'warning',
      title: 'Oops...',
      // text: 'Something went wrong!',
      ...options
    })
  }

  topEndAlert(options?: SweetAlertOptions) {
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: 'Your work has been saved',
      showConfirmButton: false,
      timer: 1500,
      ...options
    })
  }

  confirmBox(confirmAction: any, options?: SweetAlertOptions, optionsSuccess?: SweetAlertOptions, successAction?: any, errorAction?:any) {
    return Swal.fire({
      title: 'Are you sure want to remove?',
      text: 'You will not be able to recover this record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
      ...options
    }).then((result) => {
      console.log('confirm Action --->', result)
      if (result.value) {
        if (confirmAction?.subscribe) {
          return confirmAction.subscribe((data: any) => {
            if (data) {
              return Swal.fire(
                {
                  title: 'Deleted!',
                  html: 'Your imaginary file has been deleted.',
                  icon: 'success',
                  ...optionsSuccess
                }
              ).then((data) => {
                return successAction();
              })
            }
            return null;
          }, (error: any) => {
            console.log("Error:", error)
            return this.errorAlert();
          })
        }else{
          // console.log(confirmAction);
          try{
            return confirmAction().then(()=>{
              return Swal.fire(
                {
                  title: 'Deleted!',
                  html: 'Your imaginary file has been deleted.',
                  icon: 'success',
                  ...optionsSuccess
                }
              ).then((data) => {
                return successAction();
              })
            }).catch((e:any)=>{
              this.errorAlert();
              return errorAction(e);
            });
          }catch (e:any) {
            // confirmAction();
            // return Swal.fire(
            //   {
            //     title: 'Deleted!',
            //     html: 'Your imaginary file has been deleted.',
            //     icon: 'success',
            //     ...optionsSuccess
            //   }
            // ).then((data) => {
            //   return successAction();
            // }).catch((err)=>{
            this.errorAlert();
              return errorAction(e);
            // });
          }

        }

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // Swal.fire(
        //   'Cancelled',
        //   'Your imaginary file is safe :)',
        //   'error'
        // )
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          title: 'Cancelled',
          html: 'Your item is safe :)',
          icon: 'error'
        });
        return result;
      }
    })
  }
  cancelBox(confirmAction: any, options?: SweetAlertOptions, optionsSuccess?: SweetAlertOptions, successAction?: any) {
    return Swal.fire({
      title: 'Are you sure want to cancel?',
      text: 'You will not be able to undo this change!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, cancel it!',
      cancelButtonText: 'No, keep as it is',
      ...options
    }).then((result) => {
      if (result.value) {
        confirmAction.subscribe((data: any) => {
          if (data) {
            Swal.fire(
              {
                title: 'Cancelled!',
                html: 'Your record has been cancelled.',
                icon: 'success',
                ...optionsSuccess
              }
            ).then((data) => {
              successAction();
            })
          }
        }, (error: any) => {
          this.errorAlert();
          console.log("Error:", error)
        })

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // Swal.fire(
        //   'Cancelled',
        //   'Your imaginary file is safe :)',
        //   'error'
        // )
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          title: 'Cancelled',
          html: 'Your item is safe :)',
          icon: 'error'
        })
      }
    })
  }

  toastErrorMessageAlert(options?: SweetAlertOptions) {
    return Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      title: 'Error',
      // html: 'Error occurred',
      icon: 'error',
      ...options
    })
  }

  toastSuccessMessageAlert(options?: SweetAlertOptions) {
    return Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      title: 'Success',
      html: 'Thank you...',
      icon: 'success',
      ...options
    })
  }

  toastSuccessMessageAlertWithMessage(title : string) {
    return Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      title: title,
      icon: 'success',
    })
  }

  toastWarringMessageAlert(options?: SweetAlertOptions) {
    return Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      title: 'Toast',
      html: 'Sample Toast Message',
      icon: 'warning',
      ...options
    })
  }

  toastWarringMessageAlertWithMessage(title : string) {
    return Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      title: title,
      icon: 'warning',
    })
  }

  errorAlertWithMessage(title: string) {
    return Swal.fire({
      icon: 'error',
      title: title,
    
     
    })
  }

  /**
   * Shows a reusable custom popup with icon, title, description, and optional action buttons
   * @param config Configuration object for the popup
   * @returns Promise that resolves when popup is closed
   */
  customInfoPopup(config: {
    icon: string;
    title: string;
    description?: string;
    primaryButton?: {
      text: string;
      action?: () => void;
    };
    secondaryButton?: {
      text: string;
      action?: () => void;
    };
    width?: string;
    allowOutsideClick?: boolean;
    allowEscapeKey?: boolean;
  }) {
    const {
      icon,
      title,
      description,
      primaryButton,
      secondaryButton,
      width = '450px',
      allowOutsideClick = false,
      allowEscapeKey = true
    } = config;

    // Generate unique IDs for buttons to avoid conflicts
    const primaryBtnId = `primary-btn-${Date.now()}`;
    const secondaryBtnId = `secondary-btn-${Date.now()}`;

    return Swal.fire({
      html: `
        <style>
          .custom-info-popup {
            display: flex;
            width: 100%;
            max-width: 450px;
            padding: 0 !important;
            margin: 0 auto;
            flex-direction: column;
            align-items: stretch;
            gap: 0;
            flex-shrink: 0;
            box-sizing: border-box;
          }
          .custom-info-popup .icon-section {
            display: flex;
            width: 100%;
            height: 200px;
            padding: 0 !important;
            margin: 0 !important;
            justify-content: center;
            align-items: center;
            border-radius: 8px 8px 0 0;
            background: #F7F7F7;
            box-sizing: border-box;
          }
          .custom-info-popup .info-icon {
            width: 80px;
            height: 80px;
            object-fit: contain;
          }
          .custom-info-popup .text-section {
            text-align: center;
            width: 100%;
            padding: 24px 40px 0 40px;
          }
          .custom-info-popup h2 {
            color: #000;
            text-align: center;
            font-family: 'Outfit', sans-serif;
            font-size: 20px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            margin-bottom: 10px;
            margin-top: 0;
          }
          .custom-info-popup .description {
            color: #000;
            text-align: center;
            font-family: 'Outfit', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 125%;
            margin: 0;
          }
          .custom-info-popup .actions-section {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
            width: 100%;
            padding: 24px 40px 24px 40px;
          }
          .custom-info-popup .primary-button {
            display: flex;
            height: 44px;
            padding: 12px 24px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            border-radius: 100px;
            background: linear-gradient(90deg, #FFBB07 0%, #EF1A23 100%);
            color: white;
            border: none;
            cursor: pointer;
            font-family: 'Outfit', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 125%;
            width: auto
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          .custom-info-popup .primary-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(255, 60, 0, 0.3);
          }
          .custom-info-popup .primary-button:active {
            transform: translateY(0);
          }
          .custom-info-popup .secondary-link {
            color: #939598;
            text-align: center;
            font-family: 'Outfit', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 125%;
            text-decoration: none;
            cursor: pointer;
          }
          .custom-info-popup .secondary-link:hover {
            text-decoration: underline;
          }
        </style>
        <div class="custom-info-popup">
          <div class="icon-section">
            <img src="${icon}" alt="Info Icon" class="info-icon" />
          </div>
          <div class="text-section">
            <h2>${title}</h2>
            ${description != null && description !== undefined ? `<p class="description">${description}</p>` : ''}
          </div>
          <div class="actions-section">
            ${primaryButton ? `<button class="primary-button" id="${primaryBtnId}">${primaryButton.text}</button>` : ''}
            ${secondaryButton ? `<a class="secondary-link" id="${secondaryBtnId}">${secondaryButton.text}</a>` : ''}
          </div>
        </div>
      `,
      width: width,
      padding: '0',
      showConfirmButton: false,
      showCancelButton: false,
      allowOutsideClick: allowOutsideClick,
      allowEscapeKey: allowEscapeKey,
      customClass: {
        popup: 'custom-info-popup-container',
        container: 'custom-info-popup-wrapper'
      },
      didOpen: () => {
        // Apply additional container styles to ensure proper display
        const popup = document.querySelector('.swal2-popup.custom-info-popup-container') as HTMLElement;
        if (popup) {
          popup.style.padding = '0';
          popup.style.borderRadius = '8px';
          popup.style.width = width;
          popup.style.margin = '0 auto';
          popup.style.overflow = 'hidden';
        }
        
        const htmlContainer = document.querySelector('.swal2-popup.custom-info-popup-container .swal2-html-container') as HTMLElement;
        if (htmlContainer) {
          htmlContainer.style.padding = '0';
          htmlContainer.style.margin = '0';
          htmlContainer.style.width = '100%';
        }

        const content = document.querySelector('.swal2-popup.custom-info-popup-container .swal2-content') as HTMLElement;
        if (content) {
          content.style.padding = '0';
          content.style.margin = '0';
          content.style.width = '100%';
        }

        const container = document.querySelector('.swal2-container.custom-info-popup-wrapper') as HTMLElement;
        if (container) {
          container.style.padding = '0';
          container.style.margin = '0';
        }

        if (primaryButton) {
          const primaryBtn = document.getElementById(primaryBtnId);
          if (primaryBtn) {
            primaryBtn.addEventListener('click', () => {
              Swal.close();
              if (primaryButton.action) {
                primaryButton.action();
              }
            });
          }
        }

        if (secondaryButton) {
          const secondaryBtn = document.getElementById(secondaryBtnId);
          if (secondaryBtn) {
            secondaryBtn.addEventListener('click', () => {
              Swal.close();
              if (secondaryButton.action) {
                secondaryButton.action();
              }
            });
          }
        }
      }
    });
  }

}
